/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ViewLineupsPageQueryVariables = {|
  gmID: string
|};
export type ViewLineupsPageQueryResponse = {|
  +whoAmI: ?{|
    +groups: $ReadOnlyArray<{|
      +name: string
    |}>
  |},
  +lineupSetsForGreenMachineSession: ?$ReadOnlyArray<?{|
    +id: string,
    +createdAt: any,
  |}>,
|};
export type ViewLineupsPageQuery = {|
  variables: ViewLineupsPageQueryVariables,
  response: ViewLineupsPageQueryResponse,
|};
*/


/*
query ViewLineupsPageQuery(
  $gmID: ID!
) {
  whoAmI {
    groups {
      name
    }
    id
  }
  lineupSetsForGreenMachineSession(greenMachineSessionId: $gmID) {
    id
    createdAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "gmID"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "GroupType",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "greenMachineSessionId",
      "variableName": "gmID"
    }
  ],
  "concreteType": "GreenMachineLineupSetType",
  "kind": "LinkedField",
  "name": "lineupSetsForGreenMachineSession",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewLineupsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewLineupsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "8c55f27ff23968e836631b4fbb7356f0",
    "id": null,
    "metadata": {},
    "name": "ViewLineupsPageQuery",
    "operationKind": "query",
    "text": "query ViewLineupsPageQuery(\n  $gmID: ID!\n) {\n  whoAmI {\n    groups {\n      name\n    }\n    id\n  }\n  lineupSetsForGreenMachineSession(greenMachineSessionId: $gmID) {\n    id\n    createdAt\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '56a8b97fed949ad885648f3ee204e982';

module.exports = node;
